'use client'

import {observer} from 'mobx-react'

import {PageType} from '@/src/core/domain/entities/page'

import {useStore} from '@/src/shared/hooks/useStore'
import {LayoutMeta} from '@/src/shared/ui/layout/ui/meta'
import {PageTitle} from '@/src/shared/ui/layout/ui/page-title'
import {LayoutUI} from '@/src/shared/ui/layout/ui/styles'

import * as UI from './meta.styled'
import {NewsPagination} from './pagination'
import {ArticlesListContent, NewsListContent} from './types'

export const NewsMeta = observer(({title: titleText}: {title: string}) => {
  const {pageData} = useStore<(ArticlesListContent | NewsListContent)>()

  let title: React.ReactNode = ''

  if (pageData?.type === PageType.NewsList || pageData?.type === PageType.ArticlesList) {
    title = (
      <>
        <h1>{titleText}</h1>
        {'news_list' in pageData.content && pageData.content.news_list.pages > 1 && (
          <NewsPagination key="news-pagination" />
        )}
      </>
    )
  } else if (pageData?.type === PageType.NewsDetail && 'news' in pageData.content) {
    title = <UI.Title>{pageData.content?.title}</UI.Title>
  }

  return <LayoutUI.Meta as={LayoutMeta} title={<PageTitle>{title}</PageTitle>} breadcrumbs={pageData?.breadcrumbs ?? []} />
})

export const ArticlesPageMeta = () => <NewsMeta title="Статьи" />
export const NewsPageMeta = () => <NewsMeta title="Новости" />
